import { IdentityApiError } from "./physicalIdentityApi";
import { stockRequest } from "./identityStockApi";

export type PoolCounts = { inPool: number; notReceived?: number; allotted: number; unused: number; attached: number; replacedDamaged: number };
export type PoolBatchStatus = "GENERATED" | "SENT_TO_VENDOR" | "RECEIVED";
export type PoolBatch = { batchId: string; quantity: number; carrierType: string; status: PoolBatchStatus; nextStatus?: PoolBatchStatus | null;
  serialStart?: number; serialEnd?: number; firstSerial: string; lastSerial: string; createdAt?: string; sentAt?: string; receivedAt?: string; counts: PoolCounts };
export type PoolBatchPage = { environment: string; page: number; pageSize: number; total: number; labelSizeMm: number; items: PoolBatch[] };
export type PoolStudio = { studioId: string; name: string; counts: PoolCounts };
export type PoolStudios = { environment: string; inPool: number; notReceived?: number; items: PoolStudio[] };
export type PdfLayout = "SHEET" | "ROLL";

export const poolBatches = (page: number) => stockRequest<PoolBatchPage>(false, "/pool/batches?page=" + page);
export const poolStudios = () => stockRequest<PoolStudios>(false, "/pool/studios");
export const advancePoolBatch = (batchId: string, status: PoolBatchStatus) =>
  stockRequest<{ status: PoolBatchStatus }>(false, "/pool/batches/" + encodeURIComponent(batchId) + "/status", { status });
export const allotPoolRange = (body: { serialStart: number; serialEnd: number; studioId: string; reason: string }) =>
  stockRequest<{ quantity: number }>(false, "/pool/allotments", body);

/** HKP-001234, HKP001234 or 1234 → 1234. Anything else is not a printed serial. */
export function parseSerial(raw: string): number | undefined {
  const match = raw.trim().match(/^(?:HK[PB]-?)?(\d{1,9})$/i);
  const value = match ? Number(match[1]) : NaN;
  return Number.isSafeInteger(value) && value > 0 ? value : undefined;
}

/** The vendor PDF, checked complete on the server. Errors arrive as the usual JSON body. */
export async function downloadPoolPdf(batchId: string, sizeMm: number, layout: PdfLayout): Promise<Blob> {
  const token = localStorage.getItem("token");
  const headers: Record<string, string> = {};
  if (token && token !== "null") headers.Authorization = `Bearer ${token}`;
  const path = `/physical-identities/stock/pool/batches/${encodeURIComponent(batchId)}/labels.pdf?sizeMm=${sizeMm}&layout=${layout}`;
  let res: Response;
  try { res = await fetch((process.env.REACT_APP_SERVERURL || "") + path, { headers, cache: "no-store" }); }
  catch { throw new IdentityApiError("NETWORK_UNAVAILABLE"); }
  if (!res.ok || !(res.headers.get("Content-Type") || "").includes("application/pdf")) {
    const data = await res.json().catch(() => ({}));
    throw new IdentityApiError(data.code || (res.status === 401 ? "SESSION_EXPIRED" : "REQUEST_FAILED"));
  }
  return res.blob();
}
